import { useDataSubmit } from 'Simple/Data.js'

export function isDisabled(letter, loading) {
  return !letter.template_id || !letter.recipient_id || loading
}

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'selected',
  })

  return async function onClick() {
    await submit({ type: 'edit_letter' })
  }
}
